import React from 'react';
export type IntercomSettings = typeof window.intercomSettings;

export interface IntercomContextProps {
    isInitialized: boolean;
    showMessenger: () => void;
    onMessengerHide: (callback: () => void) => void;
}

const IntercomContext = React.createContext<IntercomContextProps | undefined>(undefined);
IntercomContext.displayName = 'IntercomContext';

export default IntercomContext;
